import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"

const applicationRoutes: RouteRecordRaw[] = [
  {
    path: "/applications",
    name: "applications",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.applications.pcfExchange.path,
        name: routePaths.applications.pcfExchange.pathName,
        component: () => import("@/modules/error/PageNotFound.vue"),
        // component: () => import("@/modules/applications/pcfExchange/pages/pcfExchange.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "PCF Exchange",
              translationKey: "sideMenu.pcfExchange"
            }
          ]
        }
      },
      {
        path: routePaths.applications.pcfRequests.path,
        name: routePaths.applications.pcfRequests.pathName,
        component: () => import("@/modules/error/PageNotFound.vue"),
        // component: () => import("@/modules/applications/pcfRequests/pages/pcfRequests.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "PCF Requests",
              translationKey: "sideMenu.pcfRequests"
            }
          ]
        }
      }
    ]
  }
]

export default applicationRoutes
